// src/components/AvatarModal.jsx

import React from"react";

const avatarList = [
"/user image.webp",
"/malelogo1.png",
"/malelogo2.png",
"/malelogo3.png",
"/femalelogo1.png",
"/femalelogo2.png",
"/femalelogo3.png",
];

export default function AvatarModal({ onSelect, onClose }) {
 return (
 <div className="fixed inset-0 bg-bgMain bg-opacity-70 flex justify-center items-center z-50">
 <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-xl">
 <h2 className="text-xl font-bold text-center mb-4 text-gray-800">Choose Your Avatar</h2>
 <div className="grid grid-cols-3 gap-4">
 {avatarList.map((avatar) => (
 <img
 key={avatar}
 src={avatar}
 alt="avatar"
 className="w-20 h-20 rounded-full cursor-pointer border-2 hover:border-primary transition-transform duration-200 hover:scale-105"
 onClick={() => {
 onSelect(avatar);
 onClose();
 }}
 />
 ))}
 </div>
 <button
 className="mt-6 text-sm text-gray-500 hover:text-red-500 w-full text-center"
 onClick={onClose}
 >
 Cancel
 </button>
 </div>
 </div>
 );
}



